export function useStateUtils({
  options,
  namespace,
  config = {
    state: 'state',
    text: 'text',
    alarmList: [],
    normalList: []
  }
}) {
  /**
   * 状态选项map
   */
  const stateMap = options.reduce((map, e) => {
    map[e[config.state]] = e;
    return map;
  }, {});

  /**
   * 状态选项map
   */
  const stateTextMap = options.reduce((map, e) => {
    map[e[config.text]] = e;
    return map;
  }, {});

  /**
   * 获取状态文本
   * @param {string|number} state
   */
  function getStateText(state) {
    if (!(state in stateMap)) return;

    return stateMap[state][config.text];
  }

  function getStateByText(text) {
    if (!(text in stateTextMap)) return;
    return stateTextMap[text][config.state];
  }

  function getOption(state) {
    if (!(state in stateMap)) return;
    return stateMap[state];
  }

  function isAlarm(state) {
    return config.alarmList.includes(state);
  }

  function isNormal(state) {
    return config.normalList.includes(state);
  }

  function getBy(prop, value) {
    const item = options.find(e => e[prop] === value);

    return item;
  }

  const methods = Object.freeze({
    [`${namespace}StateTextGetter`](state) {
      return getStateText(state);
    },
    [`${namespace}StateOptionGetter`](state, prop) {
      return getOption(state)[prop];
    }
  });

  const mixins = {
    filters: methods,
    methods
  };

  return {
    options,
    mixins,
    stateMap,
    getStateText,
    getStateByText,
    getOption,
    getBy,
    isNormal,
    isAlarm
  };
}
